import { render, staticRenderFns } from "./BreadView.vue?vue&type=template&id=b4c7f842&scoped=true&"
import script from "./BreadView.vue?vue&type=script&lang=js&"
export * from "./BreadView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=b4c7f842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c7f842",
  null
  
)

export default component.exports